import { render, staticRenderFns } from "./ImageUploadProfile.vue?vue&type=template&id=72aa97da&"
import script from "./ImageUploadProfile.vue?vue&type=script&lang=js&"
export * from "./ImageUploadProfile.vue?vue&type=script&lang=js&"
import style0 from "./ImageUploadProfile.vue?vue&type=style&index=0&id=72aa97da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports